import type { SVGProps } from 'react';
const DawnFlagGD = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-GD_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-GD_svg__a)">
      <path fill="#E42235" d="M0 0h22v16H0z" />
      <path fill="#079B77" d="M2.096 2.133h17.809v11.733H2.096z" />
      <mask
        id="dawn-flag-GD_svg__b"
        width={18}
        height={12}
        x={2}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M2.096 2.133h17.809v11.733H2.096z" />
      </mask>
      <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-GD_svg__b)">
        <path
          fill="#FFD938"
          d="M3.452 8.105c.297.484.722.803 1.119.885.218.045-.181-.975-.007-1.086.148-.094.864.754.926.577.144-.407.06-.984-.261-1.506-.46-.75-.478-.255-1.721-.792.13.768-.516 1.173-.056 1.922"
        />
        <path fill="#FFD93B" d="m11 8 8.905-5.867H2.095zm0 0-8.904 5.867h17.81z" />
        <path
          fill="url(#dawn-flag-GD_svg__c)"
          d="M11 10.667c1.447 0 2.62-1.194 2.62-2.667S12.447 5.333 11 5.333C9.555 5.333 8.383 6.527 8.383 8S9.554 10.667 11 10.667"
        />
        <path
          fill="#FFD938"
          d="m11 8.823-1.231.903.463-1.472-1.224-.913 1.518-.007L11 5.867l.475 1.467 1.517.007-1.224.913.463 1.472z"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-GD_svg__c"
        x1={8.382}
        x2={8.382}
        y1={5.333}
        y2={10.667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E21C30" />
        <stop offset={1} stopColor="#CE1225" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagGD;
